var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospitalInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.933,
    height: 59.192,
    viewBox: "0 0 43.933 59.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12913",
    d: "M7.9 4.954h6.88A3.558 3.558 0 0 0 18.327 8.5h8.56a3.559 3.559 0 0 0 3.551-3.547h6.873a6.28 6.28 0 0 1 6.263 6.263v41.12a6.28 6.28 0 0 1-6.263 6.264H7.9a6.28 6.28 0 0 1-6.263-6.263V11.216A6.28 6.28 0 0 1 7.9 4.954z",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(-.641 -.406)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12914",
    d: "M18.327 1.406h8.56a3.547 3.547 0 1 1 0 7.094h-8.56a3.547 3.547 0 1 1 0-7.094z",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(-.641 -.406)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12915",
    d: "M19.807 15.917h5.6v3.737h3.736v5.6h-3.736v3.736h-5.6v-3.737h-3.736v-5.6h3.736z",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(-.641 -.406)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12916",
    d: "M8.991 36.888H30.5",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(-.641 -.406)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12917",
    d: "M8.991 43.712H25.33",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(-.641 -.406)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12918",
    d: "M8.991 50.539H25.33",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(-.641 -.406)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalInformation);
export default __webpack_public_path__ + "static/media/hospital-information.bcaefa2420ea1021031140b59e977e9e.svg";
export { ForwardRef as ReactComponent };